import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { auth, db } from '../../firebase_config';

const CreateEmployee = ({ onClose }) => {
  const { currentUser } = useAuth();
  const { loadAllData } = useData();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: 'employee',
    department: '',
    password: 'password123' // Default password
  });

  // Only allow Owner to access this
  if (currentUser?.role !== 'owner') {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-header">
            <h3>Access Denied</h3>
            <button onClick={onClose} className="modal-close">×</button>
          </div>
          <div className="modal-body">
            <p>Only owners can create new employees.</p>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Create Firebase Auth user
      const result = await createUserWithEmailAndPassword(
        auth, 
        formData.email, 
        formData.password
      );

      // Create Firestore user document
      await setDoc(doc(db, 'users', result.user.uid), {
        name: formData.name,
        email: formData.email,
        role: formData.role,
        department: formData.department,
        joinDate: new Date().toISOString().split('T')[0],
        isActive: true,
        createdAt: new Date().toISOString(),
        createdBy: currentUser.id || currentUser.uid
      });

      toast.success(`${formData.role.replace('_', ' ')} created successfully!`);
      
      // Reload data to show new user
      await loadAllData();
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        role: 'employee',
        department: '',
        password: 'password123'
      });

      if (onClose) onClose();

    } catch (error) {
      console.error('Error creating employee:', error);
      
      let errorMessage = 'Failed to create user';
      if (error.code === 'auth/email-already-in-use') {
        errorMessage = 'Email already exists';
      } else if (error.code === 'auth/weak-password') {
        errorMessage = 'Password is too weak';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Invalid email address';
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>Create New Employee</h3>
          <button onClick={onClose} className="modal-close">×</button>
        </div>
        
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Full Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter full name"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email Address *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter email address"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Role *</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="employee">Employee</option>
                <option value="project_manager">Project Manager</option>
                <option value="hr">HR Manager</option>
                <option value="owner">Owner</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Department *</label>
              <select
                name="department"
                value={formData.department}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Select Department</option>
                <option value="Technology">Technology</option>
                <option value="Human Resources">Human Resources</option>
                <option value="Marketing">Marketing</option>
                <option value="Sales">Sales</option>
                <option value="Finance">Finance</option>
                <option value="Operations">Operations</option>
                <option value="Executive">Executive</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="text"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-control"
                placeholder="Default: password123"
              />
              <small style={{ color: '#6b7280', fontSize: '12px' }}>
                User can change password after first login
              </small>
            </div>

            <div className="modal-actions">
              <button 
                type="button" 
                onClick={onClose}
                className="btn btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Creating...' : 'Create Employee'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateEmployee;
